/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function AiInsightsView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div>
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <span style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em' }}>AI Insights</span>
          <span
            style={{
              fontSize: '10px',
              fontWeight: '600',
              padding: '2px 8px',
              borderRadius: '99px',
              background: 'color-mix(in srgb, var(--acc-fill) 14%, transparent)',
              color: 'var(--text-mid)',
            }}
          >
            {dc.t(m.aiUnread)}
          </span>
        </div>{' '}
        <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
          Progressive analysis — tracks improvements and regressions against your historical performance
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '14px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap',
        }}
      >
        {' '}
        <span
          style={{
            width: '34px',
            height: '34px',
            borderRadius: '10px',
            background: 'color-mix(in srgb, var(--acc-fill) 14%, transparent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 'none',
          }}
        >
          <i className="ph ph-target" style={{ fontSize: '16px', color: 'var(--acc-2)' }}></i>
        </span>{' '}
        <div style={{ flex: '1', minWidth: '200px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--acc)' }}>
              {dc.t(m.aiStyleLabel)}
            </span>
            <span
              style={{
                fontSize: '9px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                padding: '2px 7px',
                borderRadius: '5px',
                background: 'var(--l6)',
                color: 'var(--muted)',
              }}
            >
              Trading Style
            </span>
          </div>{' '}
          <div style={{ fontSize: '10.5px', color: 'var(--muted)', lineHeight: '1.55', marginTop: '4px' }}>
            {dc.t(m.aiStyleTip)}
          </div>{' '}
        </div>{' '}
        <button
          className="scp-4f3e86a"
          onClick={m.aiStyleEdit}
          aria-label="Edit trading identity"
          style={{
            fontSize: '11px',
            padding: '6px 13px',
            borderRadius: '99px',
            border: '1px solid var(--l12)',
            background: 'transparent',
            color: 'var(--text-mid)',
            cursor: 'pointer',
            flex: 'none',
          }}
        >
          Edit
        </button>{' '}
      </div>{' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Period
          </span>{' '}
          <div style={{ display: 'flex', gap: '6px' }}>
            {' '}
            {(m.aiPeriods ?? []).map((p, i106) => (
              <Fragment key={i106}>
                {' '}
                <button
                  onClick={p?.go}
                  aria-label={dc.a(p?.label)}
                  style={dc.css(
                    `display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:500;padding:6px 12px;border-radius:9px;border:1px solid ${dc.s(p?.bd)};background:${dc.s(p?.bg)};color:${dc.s(p?.fg)};cursor:pointer`,
                  )}
                >
                  <i className={`ph ${dc.s(p?.icon)}`} style={{ fontSize: '12px' }}></i>
                  {dc.t(p?.label)}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Account
          </span>{' '}
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {' '}
            {(m.aiAccts ?? []).map((a, i107) => (
              <Fragment key={i107}>
                {' '}
                <button
                  onClick={a?.go}
                  aria-label={dc.a(a?.label)}
                  style={dc.css(
                    `font-size:11px;padding:6px 12px;border-radius:9px;border:1px solid ${dc.s(a?.bd)};background:${dc.s(a?.bg)};color:${dc.s(a?.fg)};cursor:pointer`,
                  )}
                >
                  {dc.t(a?.label)}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,220px),1fr))',
          gap: '12px',
        }}
      >
        {' '}
        {(m.aiTypes ?? []).map((t, i108) => (
          <Fragment key={i108}>
            {' '}
            <button
              className="scp-df536b2"
              onClick={t?.go}
              aria-label={`Run ${dc.s(t?.label)} analysis`}
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '10px',
                textAlign: 'left',
                color: 'var(--text)',
                cursor: 'pointer',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '8px' }}>
                {' '}
                <span
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '9px',
                    background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 'none',
                  }}
                >
                  <i
                    className={`ph ${dc.s(t?.icon)}`}
                    style={{ fontSize: '14px', color: 'var(--acc-2)' }}
                  ></i>
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                {t?.running ? (
                  <span
                    style={{
                      fontSize: '9.5px',
                      padding: '2px 8px',
                      borderRadius: '99px',
                      background: 'var(--l6)',
                      color: 'var(--muted)',
                    }}
                  >
                    {dc.t(t?.badge)}
                  </span>
                ) : null}{' '}
                <i className="ph ph-caret-right" style={{ fontSize: '12px', color: 'var(--faint)' }}></i>{' '}
              </div>{' '}
              <div>
                <div style={{ fontSize: '12.5px', fontWeight: '600' }}>{dc.t(t?.label)}</div>
                <div
                  style={{ fontSize: '10.5px', color: 'var(--muted)', lineHeight: '1.55', marginTop: '3px' }}
                >
                  {dc.t(t?.desc)}
                </div>
              </div>{' '}
            </button>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      {m.aiEmpty ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '40px 20px',
              textAlign: 'center',
            }}
          >
            <i className="ph ph-sparkle" style={{ fontSize: '26px', color: 'var(--ghost)' }}></i>
            <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '9px' }}>
              No trades in this period
            </div>
            <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
              Widen the period or pick another account to analyse.
            </div>
          </div>{' '}
        </>
      ) : null}{' '}
      <div
        style={dc.css(
          `border:1px solid ${dc.s(m.aiTrajBd)};background:${dc.s(m.aiTrajBg)};border-radius:16px;padding:16px 18px`,
        )}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px', flexWrap: 'wrap' }}>
          {' '}
          <i className="ph ph-trend-up" style={dc.css(`font-size:14px;color:${dc.s(m.aiTrajFg)}`)}></i>{' '}
          <span style={dc.css(`font-size:12.5px;font-weight:600;color:${dc.s(m.aiTrajFg)}`)}>
            Equity Trajectory
          </span>{' '}
          <span
            style={dc.css(
              `font-size:9.5px;font-weight:700;padding:2px 8px;border-radius:99px;border:1px solid ${dc.s(m.aiTrajBd)};color:${dc.s(m.aiTrajFg)}`,
            )}
          >
            {dc.t(m.aiTrajLabel)}
          </span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <span
            style={dc.css(
              `font-size:13px;font-weight:700;color:${dc.s(m.aiTrajFg)};font-variant-numeric:tabular-nums`,
            )}
          >
            {dc.t(m.aiGrowth)}
          </span>{' '}
        </div>{' '}
        <div
          style={dc.css(
            `font-size:12px;color:var(--text2);line-height:1.65;margin-top:11px;padding-left:11px;border-left:2px solid ${dc.s(m.aiTrajBd)};max-width:88ch`,
          )}
        >
          {dc.t(m.aiTrajSummary)}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '10.5px',
            color: 'var(--muted)',
            marginTop: '10px',
          }}
        >
          <i className="ph ph-activity" style={{ fontSize: '12px', color: 'var(--acc-2)' }}></i>Projected
          monthly growth at current pace:
          <span style={{ fontWeight: '600', color: 'var(--acc)' }}>{dc.t(m.aiProjected)}</span>
        </div>{' '}
      </div>{' '}
      {m.aiHasSignals ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              borderColor: 'color-mix(in srgb, var(--pos) 25%, transparent)',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="ph-fill ph-star" style={{ fontSize: '13px', color: 'var(--pos)' }}></i>
              <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--pos)' }}>
                Discipline Signals
              </span>
              <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.aiSignalCount)}</span>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '11px' }}>
              {' '}
              {(m.aiSignals ?? []).map((s, i109) => (
                <Fragment key={i109}>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      padding: '11px 13px',
                      borderRadius: '11px',
                      border: '1px solid color-mix(in srgb, var(--pos) 20%, transparent)',
                      background: 'color-mix(in srgb, var(--pos) 5%, transparent)',
                    }}
                  >
                    <i
                      className="ph ph-check-circle"
                      style={{ fontSize: '13px', color: 'var(--pos)', flex: 'none', marginTop: '1px' }}
                    ></i>
                    <div>
                      <div style={{ fontSize: '11.5px', fontWeight: '600', color: 'var(--pos-2)' }}>
                        {dc.t(s?.signal)}
                      </div>
                      <div
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted)',
                          lineHeight: '1.55',
                          marginTop: '3px',
                        }}
                      >
                        {dc.t(s?.detail)}
                      </div>
                    </div>
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.aiHasFlags ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="ph ph-warning" style={{ fontSize: '13px', color: 'var(--neg)' }}></i>
              <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--neg)' }}>Risk Flags</span>
              <span style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(m.aiFlagCount)}</span>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '11px' }}>
              {' '}
              {(m.aiFlags ?? []).map((f, i110) => (
                <Fragment key={i110}>
                  {' '}
                  <div
                    style={dc.css(
                      `display:flex;align-items:flex-start;gap:10px;padding:11px 13px;border-radius:11px;border:1px solid ${dc.s(f?.bd)};background:${dc.s(f?.bg)}`,
                    )}
                  >
                    {' '}
                    <i
                      className="ph ph-warning-circle"
                      style={dc.css(`font-size:13px;color:${dc.s(f?.fg)};flex:none;margin-top:1px`)}
                    ></i>{' '}
                    <div style={{ flex: '1', minWidth: '0' }}>
                      <div style={dc.css(`font-size:11.5px;font-weight:600;color:${dc.s(f?.fg)}`)}>
                        {dc.t(f?.title)}
                      </div>
                      <div
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted)',
                          lineHeight: '1.55',
                          marginTop: '3px',
                        }}
                      >
                        {dc.t(f?.detail)}
                      </div>
                    </div>{' '}
                    <span
                      style={dc.css(
                        `font-size:9px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:2px 8px;border-radius:99px;border:1px solid ${dc.s(f?.bd)};color:${dc.s(f?.fg)};flex:none`,
                      )}
                    >
                      {dc.t(f?.sev)}
                    </span>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
          gap: '14px',
          alignItems: 'start',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ph ph-trend-up" style={{ fontSize: '13px', color: 'var(--pos)' }}></i>
            <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--pos)' }}>What Improved</span>
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginTop: '11px' }}>
            {' '}
            {(m.aiImproved ?? []).map((i, i111) => (
              <Fragment key={i111}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    fontSize: '11.5px',
                    color: 'var(--text2)',
                    lineHeight: '1.55',
                  }}
                >
                  <i
                    className="ph ph-check-circle"
                    style={{ fontSize: '12px', color: 'var(--pos)', flex: 'none', marginTop: '2px' }}
                  ></i>
                  {dc.t(i?.t)}
                </div>
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ph ph-trend-down" style={{ fontSize: '13px', color: 'var(--neg)' }}></i>
            <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--neg)' }}>What Regressed</span>
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginTop: '11px' }}>
            {' '}
            {(m.aiRegressed ?? []).map((i, i112) => (
              <Fragment key={i112}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '8px',
                    fontSize: '11.5px',
                    color: 'var(--text2)',
                    lineHeight: '1.55',
                  }}
                >
                  <i
                    className="ph ph-x-circle"
                    style={{ fontSize: '12px', color: 'var(--neg)', flex: 'none', marginTop: '2px' }}
                  ></i>
                  {dc.t(i?.t)}
                </div>
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      {m.aiHasDeltas ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ fontSize: '12.5px', fontWeight: '600' }}>Metric deltas</div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
              This period against the one before it
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,150px),1fr))',
                gap: '12px',
                marginTop: '12px',
              }}
            >
              {' '}
              {(m.aiDeltas ?? []).map((d, i113) => (
                <Fragment key={i113}>
                  {' '}
                  <div
                    style={{
                      border: '1px solid var(--l8)',
                      borderRadius: '11px',
                      background: 'var(--l3)',
                      padding: '11px 13px',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(d?.label)}
                    </div>{' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px', marginTop: '5px' }}>
                      <span
                        style={{ fontSize: '15px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}
                      >
                        {dc.t(d?.now)}
                      </span>
                      <span
                        style={dc.css(
                          `display:inline-flex;align-items:center;gap:3px;font-size:10.5px;color:${dc.s(d?.fg)};font-variant-numeric:tabular-nums`,
                        )}
                      >
                        <i className={`ph ${dc.s(d?.icon)}`} style={{ fontSize: '11px' }}></i>
                        {dc.t(d?.d)}
                      </span>
                    </div>{' '}
                    <div
                      style={{
                        fontSize: '9.5px',
                        color: 'var(--muted2)',
                        marginTop: '3px',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {'was '}
                      {dc.t(d?.was)}
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          borderColor: 'color-mix(in srgb, var(--acc-fill) 22%, transparent)',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          {' '}
          <i className="ph ph-list-checks" style={{ fontSize: '13px', color: 'var(--acc-2)' }}></i>
          <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--acc)' }}>Action Plan</span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <button
            className="scp-4f3e86a"
            onClick={m.aiSendForward}
            aria-label="Send action plan to next session"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11px',
              padding: '5px 12px',
              borderRadius: '99px',
              border: '1px solid var(--l12)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-paper-plane-tilt" style={{ fontSize: '12px' }}></i>Send to next session
          </button>{' '}
        </div>{' '}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
          {' '}
          {(m.aiActions ?? []).map((a, i114) => (
            <Fragment key={i114}>
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '11px',
                  padding: '11px 13px',
                  borderRadius: '11px',
                  border: '1px solid var(--l8)',
                  background: 'var(--l3)',
                }}
              >
                <span
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    background: 'color-mix(in srgb, var(--acc-fill) 18%, transparent)',
                    color: 'var(--acc)',
                    fontSize: '10px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 'none',
                  }}
                >
                  {dc.t(a?.n)}
                </span>
                <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.55' }}>
                  {dc.t(a?.t)}
                </span>
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
        <span
          style={{
            fontSize: '9px',
            letterSpacing: '0.11em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
          }}
        >
          Saved insights
        </span>
        <div
          style={{ flex: '1', height: '1px', background: 'linear-gradient(90deg,var(--l10),transparent)' }}
        ></div>
      </div>{' '}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {' '}
        {(m.aiInsights ?? []).map((i, i115) => (
          <Fragment key={i115}>
            {' '}
            <div
              style={dc.css(
                `background:var(--surface);border:1px solid var(--card-line);box-shadow:var(--shadow-card);border-radius:16px;border-left:2px solid ${dc.s(i?.markBd)};overflow:hidden`,
              )}
            >
              {' '}
              <button
                className="scp-4f3e86a"
                onClick={i?.toggle}
                aria-label={dc.a(i?.title)}
                aria-expanded={dc.b(i?.open)}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  width: '100%',
                  textAlign: 'left',
                  padding: '14px 16px',
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--text)',
                  cursor: 'pointer',
                }}
              >
                {' '}
                <i
                  className={`ph ${dc.s(i?.icon)}`}
                  style={dc.css(`font-size:15px;color:${dc.s(i?.sevFg)};flex:none;margin-top:1px`)}
                ></i>{' '}
                <div style={{ flex: '1', minWidth: '0' }}>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '12.5px', fontWeight: '600' }}>{dc.t(i?.title)}</span>
                    <span
                      style={dc.css(
                        `font-size:9px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;padding:2px 8px;border-radius:99px;background:${dc.s(i?.sevBg)};color:${dc.s(i?.sevFg)}`,
                      )}
                    >
                      {dc.t(i?.sev)}
                    </span>
                    <span style={{ fontSize: '10px', color: 'var(--muted)' }}>{dc.t(i?.when)}</span>
                  </div>{' '}
                  {i?.open ? (
                    <>
                      {' '}
                      <div>
                        {' '}
                        <div
                          style={{
                            fontSize: '11.5px',
                            color: 'var(--text2)',
                            lineHeight: '1.65',
                            marginTop: '8px',
                            maxWidth: '88ch',
                          }}
                        >
                          {dc.t(i?.body)}
                        </div>{' '}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '9px' }}>
                          {' '}
                          {(i?.refs ?? []).map((r, i116) => (
                            <Fragment key={i116}>
                              <span
                                style={{
                                  fontSize: '10px',
                                  padding: '1px 7px',
                                  borderRadius: '99px',
                                  background: 'color-mix(in srgb, var(--vio-fill) 14%, transparent)',
                                  color: 'var(--text-mid)',
                                }}
                              >
                                {dc.t(r?.label)}
                              </span>
                            </Fragment>
                          ))}{' '}
                        </div>{' '}
                      </div>{' '}
                    </>
                  ) : null}{' '}
                </div>{' '}
                <i
                  className="ph ph-caret-down"
                  style={dc.css(
                    `font-size:13px;color:var(--faint);flex:none;transform:${dc.s(i?.caret)};transition:transform 160ms cubic-bezier(0.16,1,0.3,1)`,
                  )}
                ></i>{' '}
              </button>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>
    </div>
  );
}
